import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCover from './locales/en/cover.json';
import urCover from './locales/ur/cover.json';
import arCover from './locales/ar/cover.json';
import enCommon from './locales/en/common.json';
import urCommon from './locales/ur/common.json';
import arCommon from './locales/ar/common.json';
import zhCover from './locales/zh/cover.json';
import frCover from './locales/fr/cover.json';
import deCover from './locales/de/cover.json';
import hiCover from './locales/hi/cover.json';
import itCover from './locales/it/cover.json';
import jaCover from './locales/ja/cover.json';
import ptCover from './locales/pt/cover.json';
import ruCover from './locales/ru/cover.json';
import esCover from './locales/es/cover.json';

import zhCommon from './locales/zh/common.json';
import frCommon from './locales/fr/common.json';
import deCommon from './locales/de/common.json';
import hiCommon from './locales/hi/common.json';
import itCommon from './locales/it/common.json';
import jaCommon from './locales/ja/common.json';
import ptCommon from './locales/pt/common.json';
import ruCommon from './locales/ru/common.json';
import esCommon from './locales/es/common.json';

// You can expand resources with more namespaces/languages later
const resources = {
  en: { cover: enCover, common: enCommon },
  ur: { cover: urCover, common: urCommon },
  ar: { cover: arCover, common: arCommon },
  zh: { cover: zhCover, common: zhCommon },
  fr: { cover: frCover, common: frCommon },
  de: { cover: deCover, common: deCommon },
  hi: { cover: hiCover, common: hiCommon },
  it: { cover: itCover, common: itCommon },
  ja: { cover: jaCover, common: jaCommon },
  pt: { cover: ptCover, common: ptCommon },
  ru: { cover: ruCover, common: ruCommon },
  es: { cover: esCover, common: esCommon }
};

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: (typeof window !== 'undefined' && window.localStorage && localStorage.getItem('lng')) || 'en',
      fallbackLng: 'en',
      debug: false,
      ns: ['cover', 'common'],
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      detection: { order: ['querystring', 'localStorage', 'navigator'] },
    });

  // Set document direction based on language (RTL for ar/ur)
  const setDir = (lng) => {
    if (typeof document !== 'undefined') {
      const rtl = ['ar', 'ur'].includes(lng && lng.split('-')[0]);
      document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr');
    }
  };
  setDir(i18n.language);
  i18n.on('languageChanged', (lng) => setDir(lng));
}

export default i18n;
